import { useEffect } from 'react';

import { useScrollControl } from '#/hooks';
import { authActions, useAuthentication } from '#/store/auth';

import { LoginStandardPopup } from './LoginStandardPopup';
import { LoginTVE } from './LoginTVE';

/**
 * Generic login component that will render actual login functionality based on enabled authentication feature.
 * Only for logging into the web app itself, second screen login is handled separately.
 */
export const Login = () => {
  const { isLoginShown, isAuthEnabled, isTve } = useAuthentication();
  const { enableScroll, disableScroll } = useScrollControl();

  useEffect(() => {
    (isLoginShown ? disableScroll : enableScroll)();

    return disableScroll;
  }, [disableScroll, enableScroll, isLoginShown]);

  if (!isLoginShown || !isAuthEnabled) {
    return null;
  }

  // TVE login flow
  if (isTve) {
    return <LoginTVE closeModal={authActions.hideLogin} />;
  }

  // standard login flow
  return <LoginStandardPopup closeModal={authActions.hideLogin} />;
};

Login.displayName = 'Login';
